import { setup } from 'xstate';

import { useMachine } from '@xstate/react';
import * as React from 'react';

function convertPixelToSvgCoord(event: TouchEvent, el = event.currentTarget as SVGGElement) {
  const svg = el.ownerSVGElement!;
  let p = svg.createSVGPoint();
  const firstTouch = event.changedTouches[0];
  p.x = firstTouch.clientX;
  p.y = firstTouch.clientY;
  p = p.matrixTransform(svg.getScreenCTM()?.inverse());
  return p;
}

const machine = setup({
  types: {} as {
    context: {
      el?: SVGGElement;
    };
    events:
      | {
          type: 'touchstart';
          event: TouchEvent;
          el: SVGGElement;
        }
      | {
          type: 'touchmove';
          event: TouchEvent;
        }
      | {
          type: 'touchend';
          event: TouchEvent;
        };
  },
  actions: {},
}).createMachine({
  id: 'Touch event',
  initial: 'not_dragging',
  states: {
    not_dragging: {
      on: {
        touchstart: {
          target: 'dragging',
          actions: [
            ({ context, event: { el } }) => {
              context.el = el;
            },
          ],
        },
      },
    },
    dragging: {
      on: {
        touchmove: {
          actions: [
            ({ context: { el }, event: { event } }) => {
              if (el) {
                // console.log('mousedown', { event });
                const { x, y } = convertPixelToSvgCoord(event, el);
                el.setAttribute('transform', `translate(${x}, ${y})`);
              }
            },
          ],
        },
        touchend: {
          target: 'not_dragging',
          actions: [
            ({ context }) => {
              context.el = undefined;
            },
          ],
        },
      },
    },
  },
});

function ByTouchEvent() {
  const [state, send] = useMachine(machine);
  const refG = React.useRef<SVGGElement>(null);
  React.useEffect(() => {
    const el = refG.current!;
    function touchstart(event: TouchEvent) {
      send({ type: 'touchstart', event, el });
    }
    function touchmove(event: TouchEvent) {
      send({ type: 'touchmove', event });
    }
    function touchend(event: TouchEvent) {
      send({ type: 'touchend', event });
    }
    el.addEventListener('touchstart', touchstart);
    el.addEventListener('touchmove', touchmove);
    el.addEventListener('touchend', touchend);
    el.addEventListener('touchcancel', touchend);
    return () => {
      el.removeEventListener('touchstart', touchstart);
      el.removeEventListener('touchmove', touchmove);
      el.removeEventListener('touchend', touchend);
      el.removeEventListener('touchcancel', touchend);
    };
  }, []);
  // console.log('MouseOnlyXState', { state });
  return (
    <div className="container rounded border border-current relative" style={{ height: '300px' }}>
      <div className="absolute" style={{ left: '50%', transform: 'translateX(-50%)' }}>
        <div className="backdrop-brightness-90 p-1 rounded-md">{state.value}</div>
      </div>
      <svg viewBox="0 0 300 100">
        <g ref={refG} className="cursor-grab" transform="translate(30, 30)">
          <circle cx={0} cy={0} stroke="black" r="30"></circle>
          <g fontSize="14" textAnchor="middle" fill="white">
            <text dy="0.0em">Drag</text>
            <text dy="1.0em">me</text>
          </g>
        </g>
      </svg>
    </div>
  );
}

export default React.memo(ByTouchEvent);
